import {
  BarChart3,
  Clock,
  FileText,
  Handshake,
  Lightbulb,
  type LucideIcon,
} from "lucide-react"

import { AriIcon } from "@/components/sidebar/icons"
import type { SuggestedPrompt } from "@/types/chat.types"

const PROMPT_META: Record<string, { icon: LucideIcon; shortLabel: string }> = {
  "Summarize my active deals": { icon: Handshake, shortLabel: "Deals" },
  "What are the key terms in my recording contract?": { icon: FileText, shortLabel: "Contracts" },
  "Show me overdue deliverables": { icon: Clock, shortLabel: "Deliverables" },
  "Compare my deal pipeline values": { icon: BarChart3, shortLabel: "Pipeline" },
}

interface AriHomeEmptyStateProps {
  suggestedPrompts: SuggestedPrompt[]
  onPromptSelect: (prompt: SuggestedPrompt) => void
  composer: React.ReactNode
}

export function AriHomeEmptyState({
  suggestedPrompts,
  onPromptSelect,
  composer,
}: AriHomeEmptyStateProps) {
  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-4">
      <div className="mb-8 flex items-center gap-3">
        <AriIcon variant="gradient" className="size-9 shrink-0" aria-hidden="true" />
        <h1 className="font-sans font-medium text-[2rem] leading-tight tracking-tight text-foreground/90 sm:text-[2.25rem]">
          Ask Ari anything
        </h1>
      </div>

      <div className="w-full">
        {composer}
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
        {suggestedPrompts.map((prompt) => {
          const meta = PROMPT_META[prompt.label]
          const Icon = meta?.icon ?? Lightbulb
          const label = meta?.shortLabel ?? prompt.label
          return (
            <button
              key={prompt.label}
              type="button"
              onClick={() => onPromptSelect(prompt)}
              className="inline-flex items-center gap-1.5 rounded-full border border-border/70 bg-background px-3.5 py-1.5 text-sm text-foreground/80 transition-colors hover:border-border hover:bg-muted/40 hover:text-foreground"
            >
              <Icon className="size-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
